
/**
 * This is for encoding a campaign data sent through the url
 * @param {*} campaignId
 * @param {*} extra
 * @returns
 */
export function encodeUrlData( campaignId = null, ...extra) {
    return btoa(JSON.stringify({ campaignId, ...extra }));
}

/**
 * Decode the Data
 * @param {String} encodedData
 * @returns {Object}
 * ```json
 * {
 *    "type":"string",
 *    "date":"string",
 *  }
 * ```
 */
export const decodeUrlData = (encodedData) => {
    try {
        const data = JSON.parse(atob(encodedData));
        return {
            // type: data.type,
            // date: data.date,
            ...data,
        };
    } catch (error) {
        log("Error decoding data:", error);
        return null; // or handle the error in an appropriate way
    }
};


